module.exports = __webpack_public_path__ + "img/reward-3.5c5110d3.svg";